import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { exportToSvg, exportToJpeg } from '../utils/exportUtils';
import { Download } from '../icons';

export const SvgPlot = ({
  imgBlob,
  className,
  alt = 'Wykres statystyczny',
  showExportButtons = true,
  exportFilename = 'wykres',
}) => {
  const [imgUrl, setImgUrl] = useState(null);

  useEffect(() => {
    if (imgBlob) {
      const url = URL.createObjectURL(imgBlob);
      setImgUrl(url);

      return () => {
        URL.revokeObjectURL(url);
        setImgUrl(null);
      };
    } else {
      setImgUrl(null);
    }
  }, [imgBlob]);

  const handleExportSvg = () => {
    if (imgBlob) {
      exportToSvg(imgBlob, `${exportFilename}.svg`);
    }
  };

  const handleExportJpeg = () => {
    if (imgBlob) {
      exportToJpeg(imgBlob, `${exportFilename}.jpg`);
    }
  };

  return (
    <div className="relative group">
      {imgUrl && (
        <img
          src={imgUrl}
          className={twMerge('w-full mb-0', className)}
          alt={alt}
        />
      )}
      {showExportButtons && imgBlob && (
        <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <button
            onClick={handleExportSvg}
            className="btn btn-sm btn-primary"
            title="Eksportuj jako SVG"
            aria-label="Eksportuj wykres jako SVG"
          >
            <Download className="h-4 w-4" />
            SVG
          </button>
          <button
            onClick={handleExportJpeg}
            className="btn btn-sm btn-secondary"
            title="Eksportuj jako JPEG"
            aria-label="Eksportuj wykres jako JPEG"
          >
            <Download className="h-4 w-4" />
            JPEG
          </button>
        </div>
      )}
    </div>
  );
};
